import { Tooltip } from '@mui/material'
import { useGetEvent } from 'api/events/events.api'
import React, { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Datetime from 'utils/datetime/datetime'
import EventChangeRequestModal from '../EventChangeRequestModal/EventChangeRequestModal'
import { EventPost } from '../events.helper'

type ChangeRequestMenuItemProps = {
  label?: string
  id: number | undefined
  item: EventPost
}

export default function ChangeRequestMenuItem({ label, id, item }: ChangeRequestMenuItemProps): ReactElement {
  const { t } = useTranslation()

  const [openChangeRequestModal, setOpenChangeRequestModal] = useState(false)

  const changeRequest = item.change_requests?.[0]
  const fetchEvent = useGetEvent(item.id).data

  return (
    <>
      <Tooltip
        title={
          changeRequest?.created_at
            ? t('Requested by {{requested_by}} at {{created_at}}', {
                requested_by: changeRequest?.created_by ?? t('Unknown'),
                created_at: Datetime.toLocalTime(changeRequest?.created_at, 'longDayTextWithoutYear'),
              })
            : ''
        }
        placement="right"
        arrow
      >
        <div
          key={id}
          className="bg-primary-1/20 rounded-sm py-4 pl-2 hover:bg-primary-1/30 cursor-pointer
          break-words overflow-wrap-anywhere "
          onClick={() => setOpenChangeRequestModal(true)}
        >
          {label}
        </div>
      </Tooltip>

      {openChangeRequestModal && fetchEvent && (
        <EventChangeRequestModal
          eventPost={fetchEvent}
          mode={'read-only'}
          closeModal={() => setOpenChangeRequestModal(false)}
        />
      )}
    </>
  )
}
